import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, SizeTypeTokens, StackAlignContent, StackAlignItems, StackHeight, StackJustifyContent, StackSelfContent, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { OtpDS } from './Otp';
import { ACTION } from "./types";
import { ROUTE } from "../../routes";
import { isMobile } from "../../configs/utils";
const _isMobile = isMobile();
export const PartnerBodyMob = (path, partnerName, partnerPhoneNumber, refCode, referredPartner, metaData, showEmailScreen) => {
    const DS = {
        partnerBodyMob: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            height: StackHeight.MATCH_PARENT,
            bgColor: ColorTokens.Primary_02,
            padding: {
                right: SizeTypeTokens.XL,
                left: SizeTypeTokens.XL,
            },
            widgetItems: [
                { id: 'partnerBodyMobSpace7', type: WIDGET.SPACE },
                {
                    id: 'partnerBodyMobReferrer',
                    type: WIDGET.PARTNER_SIGNUP_REFERRER,
                },
                { id: 'partnerBodyMobSpace0', type: WIDGET.SPACE },
                { id: 'partnerJoinedStackMob', type: WIDGET.STACK },
                { id: 'partnerBodyMobSpace1', type: WIDGET.SPACE },
                { id: 'partnerDividerMob', type: WIDGET.DIVIDER },
                { id: 'partnerBodyMobSpace2', type: WIDGET.SPACE },
                { id: 'signupComponentContainer', type: WIDGET.STACK },
                { id: 'otpComponentContainer', type: WIDGET.STACK },
                { id: 'additionalDetailContainer', type: WIDGET.STACK },
                { id: 'citySelectionContainer', type: WIDGET.STACK },
                { id: 'partnerBodyMobSpace3', type: WIDGET.SPACE },
                { id: 'voltPartnerMob', type: WIDGET.VOLT_PARTNERS },
                { id: 'partnerBodyMobSpace4', type: WIDGET.SPACE },
                { id: 'partnerBodyMobSpace5', type: WIDGET.SPACE },
                { id: 'partnerBenefitMob', type: WIDGET.PARTNER_BENEFIT },
                { id: 'partnerBodyMobSpace6', type: WIDGET.SPACE },
            ],
        },
        partnerJoinedStackMob: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            bgColor: ColorTokens.Yellow_10,
            borderConfig: {
                borderColor: ColorTokens.Orange_200,
                borderRadius: BorderRadiusTokens.BR1,
                borderWidth: {
                    all: SizeTypeTokens.Size1,
                },
            },
            padding: {
                top: SizeTypeTokens.MD,
                bottom: SizeTypeTokens.MD,
                left: SizeTypeTokens.MD,
                right: SizeTypeTokens.MD,
            },
            widgetItems: [
                { id: 'partnerJoinedStackMobIcon1', type: WIDGET.ICON },
                { id: 'partnerJoinedMobSpace0', type: WIDGET.SPACE },
                { id: 'partnerJoinedMobT1', type: WIDGET.TEXT },
            ],
        },
        signupComponentContainer: {
            type: StackType.column,
            width: StackWidth.CONTENT,
            maxWidth: _isMobile ? '100%' : 400,
            hide: showEmailScreen,
            alignItems: StackAlignItems.center,
            alignContent: StackAlignContent.center,
            alignSelf: StackSelfContent.center,
            bgColor: ColorTokens.White,
            borderConfig: {
                borderColor: ColorTokens.Primary_10,
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.Size1,
                },
            },
            padding: _isMobile ? {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XL,
            } : {
                left: SizeTypeTokens.Size32,
                right: SizeTypeTokens.Size32,
                top: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XL,
            },
            widgetItems: [
                { id: 'signupComponentContainerT1', type: WIDGET.TEXT },
                { id: 'signupComponentContainerSpace0', type: WIDGET.SPACE },
                { id: 'signupComponentPhoneNumber', type: WIDGET.INPUT },
                { id: 'signupComponentContainerSpace1', type: WIDGET.SPACE },
                { id: "platformPasswordComponent", type: WIDGET.INPUT },
                { id: "signupComponentContainerSpace1", type: WIDGET.SPACE },
                { id: 'verifyPlatformCTA', type: WIDGET.BUTTON },
                { id: 'signupComponentContainerSpace2', type: WIDGET.SPACE },
                { id: "errorTextStack", type: WIDGET.STACK },
                {
                    id: 'tc_text',
                    type: WIDGET.TERMS_TEXT,
                },
                { id: 'signupComponentContainerSpace3', type: WIDGET.SPACE },
                partnerPhoneNumber && partnerName
                    ? { id: 'signupComponentContainerT2', type: WIDGET.TEXT }
                    : {},
            ],
        },
        signupComponentContainerT1: {
            label: 'Login to Volt Money',
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.LG,
            color: ColorTokens.Grey_Night,
        },
        errorTextStack: {
            hide: true,
            type: StackType.column,
            justifyContent: StackJustifyContent.center,
            alignContent: StackAlignContent.center,
            alignItems: StackAlignItems.center,
            alignSelf: StackSelfContent.center,
            widgetItems: [
                { id: "spaceError", type: WIDGET.SPACE },
                { id: "errorText", type: WIDGET.TEXT }
            ]
        },
        spaceError: {
            size: SizeTypeTokens.LG
        },
        errorText: {
            label: 'Invalid platform code or password',
            color: ColorTokens.System_Error,
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.MD,
            lineHeight: 24
        },
        signupComponentPhoneNumber: {
            isFocus: true,
            state: InputStateToken.DEFAULT,
            title: 'Platform code',
            placeholder: 'Enter platform code',
            action: {
                type: ACTION.PLATFORM_CODE,
                payload: {
                    value: '',
                    widgetId: 'signupComponentPhoneNumber',
                },
                routeId: ROUTE.PLATFORM_SIGN_UP,
            },
            errorAction: {
                type: ACTION.DISABLE_CONTINUE_PHONE_NUMBER,
                routeId: ROUTE.PLATFORM_SIGN_UP,
                payload: {
                    value: false,
                    targetWidgetId: 'verifyPlatformCTA',
                },
            },
            successAction: {
                type: ACTION.ENABLE_CONTINUE_PHONE_NUMBER,
                routeId: ROUTE.PLATFORM_SIGN_UP,
                payload: {
                    value: true,
                    targetWidgetId: 'verifyPlatformCTA',
                },
            },
        },
        platformPasswordComponent: {
            isFocus: false,
            state: InputStateToken.DEFAULT,
            title: 'Password',
            secureTextEntry: true,
            placeholder: 'Enter platform password',
            action: {
                type: ACTION.PLATFORM_PASSWORD,
                payload: {
                    value: '',
                    widgetId: 'platformPasswordComponent',
                },
                routeId: ROUTE.PLATFORM_SIGN_UP,
            },
            errorAction: {
                type: ACTION.DISABLE_CONTINUE_PHONE_NUMBER,
                routeId: ROUTE.PLATFORM_SIGN_UP,
                payload: {
                    value: false,
                    targetWidgetId: 'verifyPlatformCTA',
                },
            },
            successAction: {
                type: ACTION.ENABLE_CONTINUE_PHONE_NUMBER,
                routeId: ROUTE.PLATFORM_SIGN_UP,
                payload: {
                    value: true,
                    targetWidgetId: 'verifyPlatformCTA',
                },
            },
        },
        verifyPlatformCTA: {
            fontSize: FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Poppins,
            label: 'Login',
            type: ButtonTypeTokens.LargeOutline,
            width: ButtonWidthTypeToken.FULL,
            action: {
                type: ACTION.VERIFY_PLATFORM_DATA,
                payload: {
                    value: '',
                    widgetId: 'verifyPlatformCTA',
                    isResend: false,
                    path: path,
                },
                routeId: ROUTE.PLATFORM_SIGN_UP,
            },
        },
        signupComponentContainerT2: {
            label: `Contact ${partnerName} at ${+partnerPhoneNumber} for queries`,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            fontSize: FontSizeTokens.XS,
            color: ColorTokens.Grey_Night,
        },
        tc_text: {
            html: ` <p style='color:#667085;font-size:10px;font-weight: 400;line-height: 16px;'>
      By proceeding, I accept <a href="https://voltmoney.in/terms" style="text-decoration:none"><span style='color:#1434CB;'>T&Cs, Privacy Policy</span></a> and <a href="https://voltmoney.in/terms" style="text-decoration:none"><span style="color:#1434CB"; > Tarrif Rates</span></a>
      </p>`,
        },
        signupComponentContainerSpace0: {
            size: SizeTypeTokens.XXXL,
        },
        signupComponentContainerSpace1: {
            size: SizeTypeTokens.XL,
        },
        signupComponentContainerSpace2: {
            size: SizeTypeTokens.MD,
        },
        signupComponentContainerSpace3: {
            size: SizeTypeTokens.MD,
        },
        ...OtpDS(path, refCode, referredPartner),
        partnerJoinedMobT1: {
            label: `2000+ Partners have joined Volt Money `,
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Night,
            lineHeight: 16,
        },
        partnerJoinedStackMobIcon1: {
            name: IconTokens.GoldenThunder,
            size: IconSizeTokens.MD,
        },
        partnerBodyMobReferrer: {
            partnerName: partnerName ? partnerName : '',
            isRefCode: partnerName ? true : false,
        },
        partnerDividerMob: {
            size: DividerSizeTokens.SM,
            color: ColorTokens.Primary_10,
        },
        voltPartnerMob: {
            showPartner: true,
        },
        partnerBenefitMob: {
            showCard: true,
        },
        partnerBodyMobSpace0: {
            size: SizeTypeTokens.XXXL,
        },
        partnerBodyMobSpace1: {
            size: SizeTypeTokens.XXXL,
        },
        partnerBodyMobSpace2: {
            size: SizeTypeTokens.XXXL,
        },
        partnerBodyMobSpace3: {
            size: SizeTypeTokens.XXXL,
        },
        partnerBodyMobSpace4: {
            size: SizeTypeTokens.XXXL,
        },
        partnerBodyMobSpace5: {
            size: SizeTypeTokens.XXXL,
        },
        partnerBodyMobSpace6: {
            size: SizeTypeTokens.XXXL,
        },
        partnerBodyMobSpace7: {
            size: SizeTypeTokens.MD,
        },
        partnerJoinedMobSpace0: {
            size: SizeTypeTokens.SM,
        },
    };
    return DS;
};
